import WorkspaceAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/WorkspaceAppResource";
import WorkspaceTypeAppResource, {TYPE} from "@milestoneslabs/milestones-core-js/src/AppResources/WorkspaceTypeAppResource";
import get from 'lodash/get';

const iconsIllustrations = {
    [TYPE.HOME_IMPROVEMENT]: require('../../src/static/project-images/illustrations/homeImprovement.svg'),
    [TYPE.HOME_PURCHASE]: require('../../src/static/project-images/illustrations/homePurchase.svg'),
    [TYPE.HOME_OWNERSHIP]: require('../../src/static/project-images/illustrations/homeOwnershipKey.svg'),
    [TYPE.HOME_SALE]: require('../../src/static/project-images/illustrations/homeSale.svg'),
    [TYPE.MOVE]: require('../../src/static/project-images/illustrations/homeMove.svg'),
    [TYPE.REFINANCE]: require('../../src/static/project-images/illustrations/refinance.svg'),
    [TYPE.MORTGAGE]: require('../../src/static/project-images/illustrations/mortgage.svg'),
    //todo: Update keys for these as well, if they exists?
    maintain: require('../../src/static/project-images/illustrations/maintain.svg'),
    reverse: require('../../src/static/project-images/illustrations/reverse.svg'),
};

const icons = {
    [TYPE.HOME_IMPROVEMENT]: require('../../src/static/project-images/icons/home-improvement.svg'),
    [TYPE.HOME_PURCHASE]: require('../../src/static/project-images/icons/home-purchase.svg'),
    [TYPE.HOME_OWNERSHIP]: require('../../src/static/project-images/icons/home-ownership.svg'),
    [TYPE.HOME_SALE]: require('../../src/static/project-images/icons/home-sale.svg'),
    [TYPE.MOVE]: require('../../src/static/project-images/icons/move.svg'),
    [TYPE.REFINANCE]: require('../../src/static/project-images/icons/refinance.svg'),
    [TYPE.MORTGAGE]: require('../../src/static/project-images/icons/mortgage.svg'),
};

const inviteIllustration = {
    invite: require('../../src/static/project-images/icons/invite-confirmation.png'),
}

const getHubType = (projectType) => {
    let type = '';

    if (projectType instanceof WorkspaceTypeAppResource) {
        type = projectType.type;
    }

    if (projectType instanceof WorkspaceAppResource) {
        type = get(projectType, 'workspaceType.type', '');
    }

    if (typeof type === 'string') {
        type = projectType;
    }

    return type;
}

export const projectIllustration = (projectType) => {
    const type = getHubType(projectType);

    if (Object.keys(iconsIllustrations).includes(type)) {
        return iconsIllustrations[type];
    }

    return '';
};

export const getInviteIllustration = () => {
    return inviteIllustration['invite'];
};

export const projectIcon = (projectType) => {
    const type = getHubType(projectType);

    if (Object.keys(icons).includes(type)) {
        return icons[type];
    }

    return '';
};
